import data from "./theme.mjs";
import data$1 from "./versions.mjs";
//#region src/locales/ja/docs/index.ts
var docs_default = {
	theme: data,
	versions: data$1
};
//#endregion
export { docs_default as default };
